import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import HomeScreen from '../components/Home';

const Home: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Home</IonTitle>
          <img slot="end" className="c-header-logo" src="assets/images/recvis.png" alt="logo recvis" />
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <HomeScreen />
      </IonContent>
    </IonPage>
  );
};

export default Home;
